import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { useHistory } from 'react-router-dom'

import { Button } from '../../../../Common/Button'
import { IAbsenceNew } from '../../../AbsenceNew/IAbsenceNew'
import { IAbsenceFormBase } from '../IAbsenceFormBase'

type Props = {
  isRefetching: boolean
  absenceInfo: IAbsenceNew | IAbsenceFormBase
  isInactiveCrudButtons: boolean
  slug: 'absences' | 'general-absences'
  setIsOverlayActive: (value: boolean) => void
}

export const CrudButtons = ({
  isRefetching,
  absenceInfo,
  isInactiveCrudButtons,
  slug,
  setIsOverlayActive,
}: Props) => {
  const history = useHistory()
  if (isRefetching) return null
  if (isInactiveCrudButtons) {
    return (
      <>
        <Button bg="grey" onClick={() => setIsOverlayActive(true)}>
          <FontAwesomeIcon color="grey" icon={'pen'} />
        </Button>
        <Button bg="grey" onClick={() => setIsOverlayActive(true)}>
          <FontAwesomeIcon color="grey" icon={'trash'} />
        </Button>
      </>
    )
  }
  return (
    <>
      <Button
        onClick={() => history.push(`/hr/${slug}/edit/${absenceInfo.uuid}`)}>
        <FontAwesomeIcon icon={'pen'} />
      </Button>
      <Button onClick={() => setIsOverlayActive(true)}>
        <FontAwesomeIcon icon={'trash'} />
      </Button>
    </>
  )
}
